<section>
    <h1>A CTO for your <handwritten-text>Minimum Viable Product</handwritten-text></h1>
    <h3>
        <p>Technology Strategy as a Subscription.</p>
        <p> Start today, cancel anytime.</p>
    </h3>
  
</section>